__turbopack_context__.v({
  "clamped": "Text-module___wEZJq__clamped",
  "color-accent": "Text-module___wEZJq__color-accent",
  "color-error": "Text-module___wEZJq__color-error",
  "color-info": "Text-module___wEZJq__color-info",
  "color-jets-beige": "Text-module___wEZJq__color-jets-beige",
  "color-jets-black": "Text-module___wEZJq__color-jets-black",
  "color-jets-red": "Text-module___wEZJq__color-jets-red",
  "color-link": "Text-module___wEZJq__color-link",
  "color-neutral-100": "Text-module___wEZJq__color-neutral-100",
  "color-neutral-200": "Text-module___wEZJq__color-neutral-200",
  "color-neutral-300": "Text-module___wEZJq__color-neutral-300",
  "color-neutral-400": "Text-module___wEZJq__color-neutral-400",
  "color-neutral-500": "Text-module___wEZJq__color-neutral-500",
  "color-neutral-600": "Text-module___wEZJq__color-neutral-600",
  "color-neutral-700": "Text-module___wEZJq__color-neutral-700",
  "color-neutral-800": "Text-module___wEZJq__color-neutral-800",
  "color-neutral-900": "Text-module___wEZJq__color-neutral-900",
  "color-overImage": "Text-module___wEZJq__color-overImage",
  "color-overPrimary": "Text-module___wEZJq__color-overPrimary",
  "color-primary": "Text-module___wEZJq__color-primary",
  "color-primary-highlight": "Text-module___wEZJq__color-primary-highlight",
  "color-primary-tint": "Text-module___wEZJq__color-primary-tint",
  "color-success": "Text-module___wEZJq__color-success",
  "color-warning": "Text-module___wEZJq__color-warning",
  "color-white": "Text-module___wEZJq__color-white",
  "font-accent": "Text-module___wEZJq__font-accent",
  "font-regular": "Text-module___wEZJq__font-regular",
  "font-special": "Text-module___wEZJq__font-special",
  "lineHeight-large": "Text-module___wEZJq__lineHeight-large",
  "lineHeight-standard": "Text-module___wEZJq__lineHeight-standard",
  "lineThrough": "Text-module___wEZJq__lineThrough",
  "lines-1": "Text-module___wEZJq__lines-1",
  "lines-2": "Text-module___wEZJq__lines-2",
  "lines-3": "Text-module___wEZJq__lines-3",
  "lines-4": "Text-module___wEZJq__lines-4",
  "lines-5": "Text-module___wEZJq__lines-5",
  "priority-low": "Text-module___wEZJq__priority-low",
  "textSize-large": "Text-module___wEZJq__textSize-large",
  "textSize-small": "Text-module___wEZJq__textSize-small",
  "textSize-standard": "Text-module___wEZJq__textSize-standard",
  "textSize-xlarge": "Text-module___wEZJq__textSize-xlarge",
  "textSize-xsmall": "Text-module___wEZJq__textSize-xsmall",
  "textSize-xxlarge": "Text-module___wEZJq__textSize-xxlarge",
  "textSize-xxxlarge": "Text-module___wEZJq__textSize-xxxlarge",
  "textWeight-medium": "Text-module___wEZJq__textWeight-medium",
  "textWeight-regular": "Text-module___wEZJq__textWeight-regular",
  "textWeight-semi-strong": "Text-module___wEZJq__textWeight-semi-strong",
  "textWeight-strong": "Text-module___wEZJq__textWeight-strong",
  "transform-capitalize": "Text-module___wEZJq__transform-capitalize",
  "transform-uppercase": "Text-module___wEZJq__transform-uppercase",
  "truncate": "Text-module___wEZJq__truncate",
  "visibility-hidden": "Text-module___wEZJq__visibility-hidden",
  "whiteSpace-nowrap": "Text-module___wEZJq__whiteSpace-nowrap",
  "whiteSpace-pre-line": "Text-module___wEZJq__whiteSpace-pre-line",
  "whiteSpace-pre-wrap": "Text-module___wEZJq__whiteSpace-pre-wrap",
  "wordWrap-break-word": "Text-module___wEZJq__wordWrap-break-word",
});
